module.exports = __webpack_public_path__ + "static/media/IMG_6374 1.11058f8a.jpg";